import BackIcon from '@cp/src/assets/images/icons/BackIcon';
import cx from 'classnames';
import styles from './viewTimelines.module.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import Split from 'react-split';
import ViewStrategy from '@cp/pages/Paramount/ViewStrategy';
import APP_ROUTES from '@cp/src/layout/Routes';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getStrategiesByTenant, getTriggersByTenant } from '../../paramountActions';
import StrategiesTable from './StrategiesTable';
import TriggersTable from './TriggersTable';
import useGetTenant from '@cp/pages/Paramount/hooks/useGetTenant';
import { RootState } from '@cp/src/store';
import { ITrigger } from '@cp/pages/Paramount/interfaces';

const ViewTimelines = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toViewEditStrategy = APP_ROUTES.PARAMOUNT_EDIT_STRATEGY.path;
  const tenant = useGetTenant();
  const startegies = useSelector((state: RootState) => state.paramountSlice.strategies);
  const triggers = useSelector((state: RootState) => state.paramountSlice.triggers);
  const [searchParams] = useSearchParams();
  const timelineName = searchParams.get('timelineName');
  const filteredStrategies = startegies.filter(strategy => {
    return strategy.timelineName === timelineName;
  });
  const filteredTriggers = triggers.filter((trigger: ITrigger) => {
    return trigger.timelineName === timelineName;
  });

  useEffect(() => {
    dispatch(getStrategiesByTenant(tenant));
    dispatch(getTriggersByTenant(tenant));
  }, []);
  return (
    <div>
      <div className={styles.topNavContainer}>
        <div className={cx('cursor-pointer pt-[10px]')} onClick={() => navigate(-1)}>
          <BackIcon size={'16'} />
        </div>
      </div>
      <div>
        <Split
          className="split"
          sizes={[50, 50]}
          minSize={100}
          expandToMin={false}
          gutterSize={20}
          gutterAlign="center"
          snapOffset={30}
          dragInterval={1}
          direction="horizontal"
          cursor="col-resize"
        >
          <div className="flex flex-col overflow-auto">
            <Typography variant="h1" className=" pl-[21px] mb-8 mt-4">
              {timelineName}
            </Typography>
            <div className="px-[20px]">
              <div className="flex flex-row justify-between items-baseline">
                <Typography variant="h2" className="py-[20px] w-[50%]">
                  Strategies
                </Typography>
                <Button
                  variant="primary"
                  className="py-[4px] h-[34px]"
                  onClick={() => navigate(`${toViewEditStrategy}?type=create&entity=strategy`)}
                >
                  Create Strategy
                </Button>
              </div>
              <StrategiesTable rowData={filteredStrategies} />
            </div>
            <div className="px-[20px] mt-8">
              <div className="flex flex-row justify-between items-baseline">
                <Typography variant="h2" className="py-[20px] w-[50%]">
                  Triggers
                </Typography>
                <Button
                  variant="primary"
                  className="py-[4px] h-[34px]"
                  onClick={() => navigate(`${toViewEditStrategy}?type=create&entity=trigger`)}
                >
                  Create Triggers
                </Button>
              </div>
              <TriggersTable rowData={filteredTriggers} />
            </div>
          </div>
          <ViewStrategy />
        </Split>
      </div>
    </div>
  );
};

export default ViewTimelines;
